import { EventHandlerConfig } from "./webchat-options.model";
import { PingHandler } from "./event-handlers/ping-handler";
import { GetAccessTokenHandler } from "./event-handlers/get-access-token-handler";
import { GetCookieValueHandler } from "./event-handlers/get-cookie-value-handler";
import { GetCurrentPageHandler } from "./event-handlers/get-current-page-handler";
import { HideInputHandler } from "./event-handlers/hide-input-handler"; 
import { PostnlDataLayerEvent } from "./event-handlers/postnl-data-layer-event-handler";
import { TriggerLoginHandler } from "./event-handlers/trigger-login-handler";

const pingConfig: EventHandlerConfig = { eventId: 'ping', handler: PingHandler };
const getAccessTokenConfig: EventHandlerConfig = { eventId: 'get-access-token', handler: GetAccessTokenHandler };
const getCookieValueConfig: EventHandlerConfig = { eventId: 'get-cookie-value', handler: GetCookieValueHandler };
const getCurrentPageConfig: EventHandlerConfig = { eventId: 'get-current-page', handler: GetCurrentPageHandler };
const hideInputConfig: EventHandlerConfig = { eventId: 'hide-input', handler: HideInputHandler };
const postnlDataLayerEventConfig: EventHandlerConfig = { eventId: 'postnl-data-layer-event', handler: PostnlDataLayerEvent };
const triggerLoginConfig: EventHandlerConfig = { eventId: 'trigger-login', handler: TriggerLoginHandler };

export const DefaultEventHandlerConfigs: EventHandlerConfig[] = [
    pingConfig,
    getAccessTokenConfig,
    getCookieValueConfig,
    getCurrentPageConfig,
    hideInputConfig,
    postnlDataLayerEventConfig,
    triggerLoginConfig
];